import { Component, OnInit, Optional } from '@angular/core';
import { NgcCookieConsentService } from 'ngx-cookieconsent';
import { getApp } from '@angular/fire/app';
import { initializePerformance } from '@angular/fire/performance';

import { AnalyticsService } from './core/services/analytics.service';
import { PlatformService } from './core/services/platform.service';
import { environment } from '../environments/environment';
import { NavigationEnd, Router } from '@angular/router';
import { filter, map } from 'rxjs';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent implements OnInit {
  constructor(
    public platformService: PlatformService,
    private router: Router,
    @Optional() private ccService: NgcCookieConsentService,
    @Optional() private analyticsService: AnalyticsService
  ) {}

  async ngOnInit() {
    this.router.events
      .pipe(
        filter((event) => event instanceof NavigationEnd),
        map((event) => event as NavigationEnd)
      )
      .subscribe(() => {
        document.getElementById('main')?.scroll({ top: 0 });
      });

    if (environment.production) {
      const perf = initializePerformance(getApp(), {
        instrumentationEnabled: true,
        dataCollectionEnabled: true,
      });

      this.analyticsService.setCurrentScreen();

      this.ccService.statusChange$.subscribe((statusChanged) => {
        if (statusChanged.status === 'deny') {
          this.analyticsService?.setIsEnabled(false);
        }
        if (statusChanged.status === 'allow') {
          this.analyticsService?.setIsEnabled(true);
          this.analyticsService?.setCurrentScreen();
        }
        if (statusChanged.status === 'dismiss') {
          this.analyticsService?.setIsEnabled(true);
          this.analyticsService?.setCurrentScreen();
        }
      });
    }
  }
}
